module.exports = __webpack_public_path__ + "static/media/dashboard-highlight-admin-icon.b40b3a15.svg";